<template>
  <div class="ClassicCase-container flex-box">
    <div class="title">璞华易研PLM的典型案例</div>
    <div class="description">多行业领域的实施经验提供更加垂直化的解决方案，助力企业提升研发效率</div>
    <div class="ClassicCase-content">
      <el-carousel 
        ref="carousel" 
        :height="slideHeight + 'px'" 
        trigger="click" 
        :interval="5000" 
        arrow="never" 
        indicator-position="none" 
        @change="setActiveItem"
      >
        <el-carousel-item v-for="(item, index) in carouselList"  :key="index" :name="item.name">
          <div class="carousel-box flex-box">
            <div class="content-left">
              <el-image
                class="case-img preview-shot"
                fit="contain"
                :src="item.icon"
                :preview-src-list="previewImgs"
              />
            </div>
            <div class="content-right">
              <div class="info-wrap">
                <div class="content-name">{{ item.name }}</div>
                <div class="content-name2">{{ item.name2 }}</div>
                <div class="content-desc">
                  <template v-if="index === 0">
                    帮助客户缩短产品开发周期，上市时间缩短<span class="key-parts din">60</span><span class="key-parts">%</span>，直接物料成本降低<span class="key-parts din">5</span><span class="key-parts">%</span>，运营成本降低<span class="key-parts din">25</span><span class="key-parts">%</span>。
                  </template>
                  <template v-else>
                    {{ item.description }}
                  </template>
                </div>
              </div>
              <div class="click-button flex-box pointer">
                <span class="button-text" @click="toLink(item)">了解详情</span>
                <el-image :src="require('@/assets/images/link-to.png')" />
              </div>
            </div>
            <div class="right-bj">
              <img v-lazy="fkbj" alt="">
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="btn-wrap">
      <img class="img1" v-lazy="btn1" alt=""  @click="clickHandle(-1)">
      <img class="img2" v-lazy="btn2" alt="" @click="clickHandle(1)">
    </div>
      
  </div>
</template>
<script>
import btn1 from '@/assets/images/btn1.png'
import btn2 from '@/assets/images/btn2.png'
import al1 from '@/assets/images/al1.png'
import al2 from '@/assets/images/al2.png'
import al3 from '@/assets/images/al3.png'
import al4 from '@/assets/images/al4.png'
import al5 from '@/assets/images/al5.png'
import al6 from '@/assets/images/al6.png'
import al7 from '@/assets/images/al7.png'
import fkbj from '@/assets/images/fkbj.png'
import mobileCarouselHeight from '@/utils/mobileCarouselHeight'

export default {
  mixins: [mobileCarouselHeight],
  props: {
    bannerHeight: {
      require: true
    }
  },
  data() {
    return {
      activeInd: 0,
      btn1,
      btn2,
      fkbj,
      carouselList: [
        {
          icon: al2,
          name: '化工材料行业PLM',
          name2: 'Chemicals',
          description: '帮助客户实现实验、配方、工艺、成本等数据一体化管理，实现业务融通，提升研发效率。',
          url: '/ChemicalIndustry'
        },
        {
          icon: al6,
          name: '食品饮料行业PLM',
          name2: 'Food & Beverage',
          description: '食品、饮料、乳制品、调味品、预制菜、保健品、宠物食品..... 基于AI智能合规引擎与全流程数字化技术，覆盖从研发到上市的安全生命周期管理',
          url: '/FoodBeverage'
        },
        {
          icon: al7,
          name: '日化美妆行业PLM',
          name2: 'Daily Chemical & Beauty',
          description: '日化、个护、彩妆、护肤品、化妆品、护理品...... 基于AI智能合规引擎与全流程数字化技术，覆盖需求到备案上市的全生命周期管理',
          url: '/BeautyMakeup'
        },
        {
          icon: al5,
          name: '芯片半导体行业PLM',
          name2: 'Machinery manufactur',
          description: '帮助客户建立统一的产品数据管理平台，规范产品数据管理。',
          url: '/Semiconductor'
        },
         {
          icon: al1,
          name: '医疗器械行业PLM',
          name2: 'medical equipment',
          description: '建立符合医疗设备行业QMS体系的合规数据集和产品开发项目管理体系，对设备研发过程、资源、交付物及过程质量进行精细化管理',
          url: '/MedicalEquipment'
        },
        {
          icon: al3,
          name: '电子科技行业PLM',
          name2: 'Electronic Technolog',
          description: '帮助客户建立起集团级产品数据管理平台，建立文件存储管理机制，提升跨部门协同能力',
          url: '/ElectronTechnology'
        },
        
      
        
      ]
    }
  },
  computed: {
    previewImgs() {
      return this.carouselList.map(item => item.icon).filter(Boolean)
    }
  },
  methods: {
    toLink(item) {
      this.$router.push(item.url)
    },
    setActiveItem(val) {
      this.activeInd = val
    },
    clickHandle(val) {
      const newInd = this.activeInd + val
      if(newInd === -1) {
        this.$refs.carousel.setActiveItem(this.carouselList.length - 1)
      } else if(newInd === this.carouselList.length) {
        this.$refs.carousel.setActiveItem(0)
      } else {
        this.$refs.carousel.setActiveItem(newInd)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.ClassicCase-container {
  padding: 10rem 26rem 8.9rem;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(168deg, #FBFCFD 0%, #F4F7F9 100%);

  .title {
    font-size: 4rem;
    font-weight: 600;
    color: #333333;
    line-height: 4rem;
    margin-bottom: 2.4rem;
  }

  .description {
    font-size: 1.8rem;
    font-weight: 400;
    color: #666A77;
    line-height: 1.8rem;
    margin-bottom: 5rem;
  }

  .ClassicCase-content {
    width: 100%;
    background: #FFFFFF;
    .carousel-box {
      width: 100%;
      height: 100%;
      position: relative;
      padding: 5.4rem;
      .content-left {
        width: 70rem;
        height: 45rem;
        .case-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          object-position: center;
          cursor: zoom-in;
        }
        ::v-deep .preview-shot {
          display: block;
          .el-image__inner {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
          }
        }
      }
      .content-right {
        margin-left: 10rem;
        margin-top: 6.1rem;
        width: 46rem;
        height: 33rem;
        .info-wrap {
          height: 27.5rem;
        }
        .content-name {
          height: 3.6rem;
          font-size: 3.2rem;
          font-weight: 600;
          color: #333333;
          line-height: 3.6rem;
        }
        .content-name2 {
          height: 1.6rem;
          font-size: 1.6rem;
          font-weight: 400;
          color: #E1E5E9;
          line-height: 1.6rem;
          margin-top: 1rem;
        }
        .content-desc {
          margin-top: 2.1rem;
          width: 46rem;
          font-size: 2rem;
          font-weight: 400;
          color: #666A77;
          line-height: 3.6rem;
          .key-parts {
            color: #3674FE;
            font-size: 2.4rem;
            line-height: 3.6rem;
            font-weight: bold;
          }
        }

        .click-button {
          font-size: 2rem;
          line-height: 3rem;
          color: #FFF;
          background: linear-gradient(318deg, #0F81F4 0%, #37A4FF 100%);
          box-shadow: 0 0.7rem 2.5rem 0 rgba(15,129,244,0.2);
          border-radius: 2.7rem;
          padding: 1.2rem 2.3rem;
          border: 0.1rem solid #FFFFFF;
          align-items: center;
          width: fit-content;

          .button-text {
            margin-right: 0.8rem;
          }
          .el-image {
            width: 3rem;
            height: 3rem;
          }
        }
        
      }
      .right-bj {
        position: absolute;
        right:0;
        bottom: 0;
        width: 32.3rem;
        height: 32.6rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .btn-wrap {
    margin-top: 4.8rem;
    img {
      width: 5.4rem;
      height: 5.4rem;
      border-radius: 50%;
      cursor: pointer;
      margin: 0 1.5rem;
      // box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(255,204,196,0.6);
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(169,169,169,0.2);
    }
    .img1 {
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(169,169,169,0.2);
    }
    .img2 {
      box-shadow: 0rem 1.3rem 1.5rem 0rem rgba(255,204,196,0.6);
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .ClassicCase-container {
    padding: 3.2rem 1.6rem 2.4rem;

    .title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      text-align: center;
    }
    .description {
      font-size: 1.4rem;
      line-height: 2.2rem;
      margin-bottom: 1.6rem;
      text-align: center;
    }
    .ClassicCase-content {
      .carousel-box {
        height: auto;
        min-height: 0;
        padding: 1.6rem;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: stretch;
        align-content: center;
        .content-left,
        .content-right {
          width: 100%;
          height: auto;
          margin: 0 0 1.6rem;
          overflow: visible;
        }
        .content-left {
          margin-bottom: 1.2rem;
          .case-img {
            height: auto;
            max-height: 16rem;
            object-fit: contain;
          }
          ::v-deep .preview-shot .el-image__inner {
            height: auto;
            max-height: 16rem;
            object-fit: contain;
          }
        }
        .content-right {
          margin-top: 0;
          margin-bottom: 0;
          display: flex;
          flex-direction: column;
          .info-wrap,
          .content-desc,
          .content-name,
          .content-name2 {
            width: 100%;
            height: auto;
            white-space: normal;
            word-break: break-word;
          }
          .content-name {
            font-size: 2.2rem;
            line-height: 3rem;
          }
          .content-name2 {
            line-height: 2rem;
            margin-top: 0.6rem;
          }
          .content-desc {
            margin-top: 1.2rem;
            font-size: 1.4rem;
            line-height: 2.2rem;
            .key-parts {
              font-size: 1.6rem;
              line-height: 2.2rem;
            }
          }
          .click-button {
            margin-top: 1.2rem;
            flex-shrink: 0;
          }
        }
        .right-bj {
          display: none;
        }
      }
    }
    .btn-wrap {
      margin-top: 2rem;
    }
  }
}
</style>
